module.exports = __webpack_public_path__ + "src/assets/img/share/bgs/pleasant/9c6ee18284df4ffaba2900488cab6305.png";